import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from "@material-ui/core/Checkbox";
import styled from "@emotion/styled";

const ColumnHeadingsWrapper = styled.div`
    display: grid;
    grid-template-columns: ${ props => `repeat(${props.columnCount}, 250px)`};
    grid-auto-flow: column;    
    
    //@media (max-width: 640px){ 
    //
    //}
    //
    //@media (max-width: 768px){
    //    grid-template-columns: repeat(auto-fill, 150px);
    //}
    //
    //@media (max-width: 1024px){
    //    grid-template-columns: repeat(auto-fill, 150px);
    // }
    //
    //@media (max-width: 1200px){
    //    grid-template-columns: repeat(auto-fill, 150px);
    // }
`;

const ColumnHeading = styled.h4`
  font-size: var(--font-m);
  font-weight: 500;
  display: flex;
  align-items: center;

  &:first-of-type {
    margin-left: ${props => (props.hasIndent) ? "var(--space-s1)" : "0"};
    grid-column-start: 1;
  }
`;


function TableHeadingComponent({tableHeadings, hasCheckBox, isChecked, onCheckBoxClicked, indeterminate}) {
    return (
        <ColumnHeadingsWrapper columnCount={tableHeadings.length}>
            {
                tableHeadings.length
                    ?
                    <>
                        {tableHeadings.slice(0, 1).map(firstHeading => <ColumnHeading hasIndent={!hasCheckBox}
                                                                                      key={firstHeading.name}>
                            {
                                hasCheckBox
                                && <Checkbox
                                    indeterminate={indeterminate}
                                    value={"tableHeading"}
                                    checked={isChecked}
                                    onChange={onCheckBoxClicked}
                                    color="primary"
                                    inputProps={{
                                        'aria-label': 'primary checkbox',
                                    }}/>
                            }
                            {firstHeading.name}
                        </ColumnHeading>)}

                        {tableHeadings.slice(1).map(heading => <ColumnHeading
                            key={heading.name}>{heading.name}</ColumnHeading>)}
                    </>
                    : null
            }
        </ColumnHeadingsWrapper>
    );
}

TableHeadingComponent.propTypes = {};
TableHeadingComponent.defaultProps = {};

export default TableHeadingComponent;
